import type { NavigateOptions } from 'react-router-dom'

type AppNavigate = (to: string, options?: NavigateOptions) => void

let navigateImpl: AppNavigate | null = null

export function registerAppNavigator(navigate: AppNavigate) {
  navigateImpl = navigate

  return () => {
    if (navigateImpl === navigate) {
      navigateImpl = null
    }
  }
}

export function navigateToAppRoute(to: string, options?: NavigateOptions) {
  if (navigateImpl) {
    navigateImpl(to, options)
    return
  }

  if (typeof window !== 'undefined') {
    if (options?.replace) {
      window.location.replace(to)
      return
    }

    window.location.assign(to)
  }
}
